import './style.css';

export default class Hero {
  static selector = ".hero";
}
